import React, { useState, Fragment } from 'react';
import * as PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import { actions as deleteDocumentActions } from '../../../../../redux/healthboard/requests/delete-document-req';
import { loggedUserIdSelector } from '../../../../../redux/context/selectors';
import ActionConfirmation from '../../../../common/ActionConfirmation';
import Icon from '../../../../Icon';
import styles from './index.styl';

export function ViewDocuments({
  singleView,
  attachment,
  appointment,
  providerContext,
  formatMessage,
}) {
  const [isOpenDeleteModal, togleOpenDeleteModal] = useState(false);
  const [targetDocument, setTargetDocument] = useState(null);

  const loggedUserId = useSelector(loggedUserIdSelector);
  const dispatch = useDispatch();

  const appointmentId = appointment ? appointment.id : null;
  const document = attachment ? attachment.file : null;
  const allDocuments = appointment ? appointment.documents : [];

  const handleOpenDocument = fileUrl => {
    window.open(fileUrl);
  };

  const handleDeleteDocument = documentId => {
    dispatch(
      deleteDocumentActions.send({
        userId: loggedUserId,
        documentId,
        appointmentId,
      }),
    );
  };

  const handleOpenDeleteModal = id => {
    setTargetDocument(id);
    togleOpenDeleteModal(true);
  };

  const viewAllDocuments = () => {
    if (allDocuments.length === 0) return <div>-</div>;
    return (
      <Fragment>
        {allDocuments.map(
          ({
            id,
            name,
            fileUrl,
            documentCategory: { name: categoryName },
            documentSubcategory: { name: subcategoryName },
          }) => {
            return (
              <div key={id}>
                <div className={styles.viewAttachmentWrapper}>
                  <div
                    className={styles.documentWrapper}
                    onClick={() => handleOpenDocument(fileUrl)}
                  >
                    <Icon
                      name="icon-document-black"
                      size={32}
                      className={styles.icon}
                    />
                    <div className={styles.fileInfoWrapper}>
                      <div className={styles.fileTitle}>{name}</div>
                      <div className={styles.fileCategory}>
                        {`${categoryName}, ${subcategoryName}`}
                      </div>
                    </div>
                  </div>
                  {providerContext && (
                    <Icon
                      name="remove-member"
                      size={16}
                      className={styles.removeIcon}
                      onClick={() => handleOpenDeleteModal(id)}
                    />
                  )}
                </div>
              </div>
            );
          },
        )}
        {providerContext && (
          <ActionConfirmation
            onClose={() => {
              togleOpenDeleteModal(false);
              setTargetDocument(null);
            }}
            onSubmit={() => handleDeleteDocument(targetDocument)}
            opened={isOpenDeleteModal}
            title={formatMessage({
              id: 'appointment.documents.deleteMessage',
            })}
            actionButtonText={formatMessage({
              id: 'common.delete',
            })}
            width="xsmall"
            mobileFullScreen={false}
          />
        )}
      </Fragment>
    );
  };

  return singleView ? (
    <div>
      <div className={styles.viewAttachmentWrapper}>
        <div className={styles.documentWrapper}>
          <Icon name="icon-document-black" size={32} className={styles.icon} />
          <div className={styles.uploadFileTitle}>{document.name}</div>
        </div>
      </div>
    </div>
  ) : (
    viewAllDocuments()
  );
}

ViewDocuments.propTypes = {
  attachment: PropTypes.object,
  singleView: PropTypes.bool.isRequired,
  appointment: PropTypes.object,
  providerContext: PropTypes.bool,
  formatMessage: PropTypes.func,
};



// WEBPACK FOOTER //
// ./src/components/Healthboard/Components/VisitDocuments/ViewDocuments/index.jsx